import { noop } from 'lodash';
import { createContext } from 'react';
import { MRT_SortingState } from 'material-react-table';

const SortContext = createContext<{
  sort: MRT_SortingState;
  setSort: (sort: MRT_SortingState) => void;
}>({
  sort: [],
  setSort: () => noop(),
});

export default SortContext;
